"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
function ofType() {
    var types = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
    }
    if (types.length === 1 && Array.isArray(types[0])) {
        types = types[0];
    }
    return function (action$) { return action$.pipe(operators_1.filter(function (action) {
        return types.indexOf(action.type) >= 0;
    })); };
}
exports.ofType = ofType;
function end() {
    return function (action$) { return action$.pipe(operators_1.filter(function () {
        return false;
    })); };
}
exports.end = end;
//# sourceMappingURL=operators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/operators.js
// module id = 112
// module chunks = 0